/**
 * Junction Box Constants - Slot configurations for different equipment types
 */

// import { JunctionBoxSlot } from '../../../../lp-ui-installation-agent/src/app/models/junctionbox.model';

export const junctionBoxMaxLength = 86;
export const PadStartValue = 3;

/**
 * Standard junction box slot selection (8 slots)
 */
export const JUNCTION_BOX_SELECTION: any[] = [
  { displayOrder: 1, label: 'S 0', value: '000' },
  { displayOrder: 2, label: 'S 1', value: '001' },
  { displayOrder: 3, label: 'S 2', value: '002' },
  { displayOrder: 4, label: 'S 3', value: '003' },
  { displayOrder: 5, label: 'S 4', value: '004' },
  { displayOrder: 6, label: 'S5, S8', value: '005' },
  { displayOrder: 7, label: 'S6, S9', value: '006' },
  { displayOrder: 8, label: 'S7, S10', value: '007' },
];

/**
 * Pipe equipment junction box slot selection (86 slots)
 */
export const JUNCTION_BOX_SELECTION_PIPE: any[] = [
  { displayOrder: 1, label: 'S 0', value: '000' },
  { displayOrder: 2, label: 'S 1', value: '001' },
  { displayOrder: 3, label: 'S 2', value: '002' },
  { displayOrder: 4, label: 'S 3', value: '003' },
  { displayOrder: 5, label: 'S 4', value: '004' },
  { displayOrder: 6, label: 'S 5', value: '005' },
  { displayOrder: 7, label: 'S 6', value: '006' },
  { displayOrder: 8, label: 'S 7', value: '007' },
  { displayOrder: 9, label: 'S 8', value: '008' },
  { displayOrder: 10, label: 'S 9', value: '009' },
  { displayOrder: 11, label: 'S 10', value: '010' },
  { displayOrder: 12, label: 'S 11', value: '011' },
  { displayOrder: 13, label: 'S 12', value: '012' },
  { displayOrder: 14, label: 'S 13', value: '013' },
  { displayOrder: 15, label: 'S 14', value: '014' },
  { displayOrder: 16, label: 'S 15', value: '015' },
  { displayOrder: 17, label: 'S 16', value: '016' },
  { displayOrder: 18, label: 'S 17', value: '017' },
  { displayOrder: 19, label: 'S 18', value: '018' },
  { displayOrder: 20, label: 'S 19', value: '019' },
  { displayOrder: 21, label: 'S 20', value: '020' },
  { displayOrder: 22, label: 'S 21', value: '021' },
  { displayOrder: 23, label: 'S 22', value: '022' },
  { displayOrder: 24, label: 'S 23', value: '023' },
  { displayOrder: 25, label: 'S 24', value: '024' },
  { displayOrder: 26, label: 'S 25', value: '025' },
  { displayOrder: 27, label: 'S 26', value: '026' },
  { displayOrder: 28, label: 'S 27', value: '027' },
  { displayOrder: 29, label: 'S 28', value: '028' },
  { displayOrder: 30, label: 'S 29', value: '029' },
  { displayOrder: 31, label: 'S 30', value: '030' },
  { displayOrder: 32, label: 'S 31', value: '031' },
  { displayOrder: 33, label: 'S 32', value: '032' },
  { displayOrder: 34, label: 'S 33', value: '033' },
  { displayOrder: 35, label: 'S 34', value: '034' },
  { displayOrder: 36, label: 'S 35', value: '035' },
  { displayOrder: 37, label: 'S 36', value: '036' },
  { displayOrder: 38, label: 'S 37', value: '037' },
  { displayOrder: 39, label: 'S 38', value: '038' },
  { displayOrder: 40, label: 'S 39', value: '039' },
  { displayOrder: 41, label: 'S 40', value: '040' },
  { displayOrder: 42, label: 'S 41', value: '041' },
  { displayOrder: 43, label: 'S 42', value: '042' },
  { displayOrder: 44, label: 'S 43', value: '043' },
  { displayOrder: 45, label: 'S 44', value: '044' },
  { displayOrder: 46, label: 'S 45', value: '045' },
  { displayOrder: 47, label: 'S 46', value: '046' },
  { displayOrder: 48, label: 'S 47', value: '047' },
  { displayOrder: 49, label: 'S 48', value: '048' },
  { displayOrder: 50, label: 'S 49', value: '049' },
  { displayOrder: 51, label: 'S 50', value: '050' },
  { displayOrder: 52, label: 'S 51', value: '051' },
  { displayOrder: 53, label: 'S 52', value: '052' },
  { displayOrder: 54, label: 'S 53', value: '053' },
  { displayOrder: 55, label: 'S 54', value: '054' },
  { displayOrder: 56, label: 'S 55', value: '055' },
  { displayOrder: 57, label: 'S 56', value: '056' },
  { displayOrder: 58, label: 'S 57', value: '057' },
  { displayOrder: 59, label: 'S 58', value: '058' },
  { displayOrder: 60, label: 'S 59', value: '059' },
  { displayOrder: 61, label: 'S 60', value: '060' },
  { displayOrder: 62, label: 'S 61', value: '061' },
  { displayOrder: 63, label: 'S 62', value: '062' },
  { displayOrder: 64, label: 'S 63', value: '063' },
  { displayOrder: 65, label: 'S 64', value: '064' },
  { displayOrder: 66, label: 'S 65', value: '065' },
  { displayOrder: 67, label: 'S 66', value: '066' },
  { displayOrder: 68, label: 'S 67', value: '067' },
  { displayOrder: 69, label: 'S 68', value: '068' },
  { displayOrder: 70, label: 'S 69', value: '069' },
  { displayOrder: 71, label: 'S 70', value: '070' },
  { displayOrder: 72, label: 'S 71', value: '071' },
  { displayOrder: 73, label: 'S 72', value: '072' },
  { displayOrder: 74, label: 'S 73', value: '073' },
  { displayOrder: 75, label: 'S 74', value: '074' },
  { displayOrder: 76, label: 'S 75', value: '075' },
  { displayOrder: 77, label: 'S 76', value: '076' },
  { displayOrder: 78, label: 'S 77', value: '077' },
  { displayOrder: 79, label: 'S 78', value: '078' },
  { displayOrder: 80, label: 'S 79', value: '079' },
  { displayOrder: 81, label: 'S 80', value: '080' },
  { displayOrder: 82, label: 'S 81', value: '081' },
  { displayOrder: 83, label: 'S 82', value: '082' },
  { displayOrder: 84, label: 'S 83', value: '083' },
  { displayOrder: 85, label: 'S 84', value: '084' },
  { displayOrder: 86, label: 'S 85', value: '085' },
];
